import { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import { MerchantStatus } from '@prisma/client';

import ArrowUpIcon from 'src/assets/images/icons/ArrowUpSVG';
import CancelIcon from 'src/assets/images/icons/CancelSVG';
import OnlineIcon from 'src/assets/images/icons/OnlineSVG';
import PackageIcon from 'src/assets/images/icons/PackageSVG';

interface ServiceIconProps {
    icon: JSX.Element;
    label: number;
}

interface SummaryOfServicesProps {
    services?: {
        terminal: {
            merchantStatus: MerchantStatus;
            serviceType: string;
        }[];
        online: {
            merchantStatus: MerchantStatus;
            serviceType: string;
        }[];
    };
}

const ServiceIcon: FC<ServiceIconProps> = ({ icon, label }) => {
    return (
        <Grid
            sx={{ display: 'flex', flexDirection: 'row', padding: '4px' }}
            alignItems="center"
            gap={1}
        >
            {icon}
            <Typography sx={{ fontSize: '24px', fontWeight: 500, color: '#575757' }}>
                {label}
            </Typography>
        </Grid>
    );
};

// Function to count services by status
const countServicesByStatus = (services, serviceType, status) => {
    return services?.[serviceType]?.filter((service) => service.merchantStatus === status).length;
};

const SummaryOfServices: FC<SummaryOfServicesProps> = ({ services }) => {
    const activeTerminalServicesCount = countServicesByStatus(
        services,
        'terminal',
        MerchantStatus.ACTIVE
    );

    const activeOnlineServicesCount = countServicesByStatus(
        services,
        'online',
        MerchantStatus.ACTIVE
    );

    const cancelledTerminalServicesCount = countServicesByStatus(
        services,
        'terminal',
        MerchantStatus.CANCELLED
    );

    const cancelledOnlineServicesCount = countServicesByStatus(
        services,
        'online',
        MerchantStatus.CANCELLED
    );

    return (
        <Grid
            sx={{
                display: 'flex',
                flexDirection: 'row',
            }}
            gap={1}
            padding="0 24px 8px 48px"
        >
            <Grid md={6}>
                <Grid>
                    <Typography sx={{ fontSize: '16px', fontWeight: 400, color: '#666' }}>
                        Service Type
                    </Typography>
                </Grid>
                <ServiceIcon icon={<PackageIcon />} label="Terminal Services" />
                <ServiceIcon icon={<OnlineIcon />} label="Online Services" />
            </Grid>

            <Grid sx={{ borderLeft: '1px solid #FDC800' }} gap={1} />
            <Grid md={3} sx={{ display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                <Grid>
                    <Typography sx={{ fontSize: '16px', fontWeight: 400, color: '#666' }}>
                        Active
                    </Typography>
                </Grid>
                <ServiceIcon icon={<ArrowUpIcon />} label={activeTerminalServicesCount} />
                <ServiceIcon icon={<ArrowUpIcon />} label={activeOnlineServicesCount} />
            </Grid>
            <Grid sx={{ borderLeft: '1px solid #FDC800' }} gap={1} />
            <Grid md={3} sx={{ display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                <Grid>
                    <Typography sx={{ fontSize: '16px', fontWeight: 400, color: '#666' }}>
                        Cancelled
                    </Typography>
                </Grid>
                <ServiceIcon icon={<CancelIcon />} label={cancelledTerminalServicesCount} />
                <ServiceIcon icon={<CancelIcon />} label={cancelledOnlineServicesCount} />
            </Grid>
        </Grid>
    );
};

export default SummaryOfServices;
